<div #tooltip class="ag-tooltip corner-{{ position }} position-{{ position }}">
  <div class="header-container">
    <div class="title">{{ title }}</div>
  </div>
  <div [innerHTML]="description" class="body-regular"></div>
</div>
